"use client";

import {useLauncherConversation} from "@/hooks/useLauncherConversation";
import GailAssistantSheet from "@/components/chat/GailAssistantSheet";
import GailTopbarButton from "./GailTopbarButton";

/** Direct chat entry with the shared top-bar introduction. */
export default function GailTopbarLauncher() {
  const {open, openSheet, closeSheet, triggerRef, panelId, keyboardInteraction, sheetProps} =
    useLauncherConversation();
  return <>
    <GailAssistantSheet {...sheetProps} />
    <GailTopbarButton
      ref={triggerRef}
      aria-controls={panelId}
      aria-expanded={open}
      chatOpen={open}
      data-instant-motion={keyboardInteraction}
      onClick={() => open ? closeSheet() : openSheet()}
    />
  </>;
}
